import userReducer from "@/components/jobPosts/ducks/slice"
import { combineReducers } from "@reduxjs/toolkit"

const jobPostsReducer = combineReducers({
  user: userReducer,
})

export default jobPostsReducer
